import * as React from "react";
import {
  SingleNavMenuLink as ISingleNavMenuLink,
  SingleNavMenuLinkButton as ISingleNavMenuLinkButton,
  SingleNavMenuLinkButtonWithOptions as ISingleNavMenuLinkButtonWithOptions,
  SingleNavMenuLinkCategory as ISingleNavMenuLinkCategory,
  SingleNavMenuLinkCategoryEnd as ISingleNavMenuLinkCategoryEnd,
  SingleNavMenuLinkDivider as ISingleNavMenuLinkDivider,
  SingleNavMenuLinkSpace as ISingleNavMenuLinkSpace,
  SingleNavMenuLinkExternal as ISingleNavMenuLinkExternal,
  SingleNavMenuLinkPage as ISingleNavMenuLinkPage,
  SingleNavMenuLinkSection as ISingleNavMenuLinkSection,
  SingleNavMenuLinkAction as ISingleNavMenuLinkAction,
} from "../../../pages/identity/useNavMenu";
import { SingleNavMenuLinkCategory } from "./singleNavMenuLinkCategory";
import { SingleNavMenuLinkDivider } from "./singleNavMenuLinkDivider";
import { SingleNavMenuLinkSpace } from "./singleNavMenuLinkSpace";
import { SingleNavMenuLinkExternal } from "./singleNavMenuLinkExternal";
import { SingleNavMenuLinkPage } from "./singleNavMenuLinkPage";
import { SingleNavMenuLinkSection } from "./singleNavMenuLinkSection";
import { SingleNavMenuLinkButton } from "./singleNavMenuLinkButton";
import { SingleNavMenuLinkButtonWithOptions } from "./singleNavMenuLinkButtonWithOptions";
import { SingleNavMenuLinkCategoryEnd } from "./singleNavMenuLinkCategoryEnd";
import { SingleNavMenuLinkAction } from "./singleNavMenuLinkAction";

interface Props {
  link: ISingleNavMenuLink;
  index: number;
}
export const SingleNavMenuLink: React.FC<Props> = ({ link, index }) => {
  if ((link as ISingleNavMenuLinkCategory).isCategory) {
    return <SingleNavMenuLinkCategory link={link as ISingleNavMenuLinkCategory} index={index} />;
  }
  if ((link as ISingleNavMenuLinkCategoryEnd).isCategoryEnd) {
    return <SingleNavMenuLinkCategoryEnd link={link as ISingleNavMenuLinkCategoryEnd} index={index} />;
  }
  if ((link as ISingleNavMenuLinkDivider).isDivider) {
    return <SingleNavMenuLinkDivider link={link as ISingleNavMenuLinkDivider} index={index} />;
  }
  if ((link as ISingleNavMenuLinkSpace).isSpace) {
    return <SingleNavMenuLinkSpace link={link as ISingleNavMenuLinkSpace} index={index} />;
  }
  if ((link as ISingleNavMenuLinkExternal).isExternal) {
    return <SingleNavMenuLinkExternal link={link as ISingleNavMenuLinkExternal} index={index} />;
  }
  if ((link as ISingleNavMenuLinkPage).isPage) {
    return <SingleNavMenuLinkPage link={link as ISingleNavMenuLinkPage} index={index} />;
  }
  if ((link as ISingleNavMenuLinkSection).isSection) {
    return <SingleNavMenuLinkSection link={link as ISingleNavMenuLinkSection} index={index} />;
  }
  if ((link as ISingleNavMenuLinkButton).isButton) {
    return <SingleNavMenuLinkButton link={link as ISingleNavMenuLinkButton} index={index} />;
  }
  if ((link as ISingleNavMenuLinkButtonWithOptions).isButtonWithOptions) {
    return <SingleNavMenuLinkButtonWithOptions link={link as ISingleNavMenuLinkButtonWithOptions} index={index} />;
  }
  if ((link as ISingleNavMenuLinkAction).isAction) {
    return <SingleNavMenuLinkAction link={link as ISingleNavMenuLinkAction} index={index} />;
  }
  return null;
};
